<!--CONTRATO DE CRÉDITO CON GARANTÍA HIPOTECARIA- PERSONA FISICA-->
<template>
    <div class="page-simulator">
        <form class="form-inline contract-container single-page-mode" @submit.prevent="handleSubmit">
            <div class="content-ref" ref="contractContent">

                <!-- Contenedor principal que simula el papel -->

                <!-- Page 1 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->

                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                        <div class="contract-title text-uppercase">
                                            <p>
                                                <strong>CONTRATO DE CRÉDITO CON GARANTÍA HIPOTECARIA</strong>, CUYO NÚMERO DE IDENTIFICACIÓN SE INDICA EN LA CARÁTULA
                                                BAJO EL RUBRO "NÚMERO DE CONTRATO", QUE CELEBRAN POR UNA PARTE LA SOCIEDAD <strong>KVF GROUP, S.A. DE C.V.</strong>,
                                                RECONOCIDA COMO EL ACREDITANTE, A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ COMO <strong>"GOLDBERGFUND"</strong>, Y POR
                                                OTRA PARTE LA PERSONA FÍSICA CUYO NOMBRE SE INDICA EN LA CARÁTULA DEL PRESENTE CONTRATO, RECONOCIDA 
                                                COMO EL ACREDITADO, EN LO SUCESIVO <strong>"EL ACREDITADO"</strong>, Y LA PERSONA MORAL O FÍSICA CUYA DENOMINACIÓN, RAZÓN
                                                SOCIAL O NOMBRE RESPECTIVAMENTE, SE INDICAN EN LA CARÁTULA DEL PRESENTE CONTRATO, RECONOCIDO COMO EL
                                                OBLIGADO SOLIDARIO, EN LO SUCESIVO <strong>"EL OBLIGADO SOLIDARIO"</strong>, QUIENES SE SUJETAN AL TENOR DE LAS SIGUIENTES
                                                DECLARACIONES Y CLÁUSULAS:
                                            </p>
                                        </div>
                                    </div>

                                    <div class="section-title text-uppercase">DECLARACIONES:</div>
                                    <div class="title-clausula-exception">
                                        <strong>
                                            I.- Declara GOLDBERGFUND, por conducto de su representante legal, y bajo
                                            protesta de decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Que está legalmente constituida conforme a las leyes
                                        mexicanas
                                        según consta en la Escritura Pública número 235
                                        con fecha diez de febrero de dos mil dieciséis, pasada ante la fe del Lic.
                                        Gabriela
                                        Alejandra González López, Notario
                                        Público número 82 en el Estado de Quintana Roo;
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que su representada le otorgó facultades suficientes para
                                        comparecer a la celebración del presente contrato,
                                        mismas que a la fecha no le han sido revocadas, modificadas o restringidas de
                                        forma
                                        alguna.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong> Para todos los efectos del presente contrato, señala como
                                        domicilio para oír y recibir notificaciones el ubicado en
                                        Calle Robert Schumann, Número 4898, Colonia Lomas del Seminario, Zapopan,
                                        Jalisco,
                                        C.P 45038.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong> Que es su deseo celebrar el presente contrato con <strong>EL
                                            ACREDITADO</strong> y el <strong>OBLIGADO SOLIDARIO</strong> en virtud de
                                        contar
                                        con la capacidad y experiencia necesaria para el cumplimiento del presente
                                        contrato
                                        en los términos y condiciones que
                                        más adelante se indican.
                                    </div>

                                    <div class="title-clausula">
                                        <strong>
                                            II.- Declara EL ACREDITADO, por su propio y personal derecho, y bajo
                                            protesta de
                                            decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Es una persona física, mayor de edad, con plena capacidad
                                        para
                                        contratar y obligarse con los términos de este
                                        contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que tanto la información y los datos generales
                                        proporcionados en
                                        la carátula del presente contrato (Anexo A) y
                                        consignada como los datos patrimoniales que ha entregado con anterioridad a
                                        <strong>GOLDBERGFUND</strong> son verdaderos, y que
                                        presentan de manera exacta y fiel su situación financiera al momento de la firma
                                        del
                                        presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong> Para todos los efectos del presente contrato, señala como
                                        domicilio para oír y recibir notificaciones el señalado en
                                        la carátula de este contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong> Tener la debida capacidad jurídica y económica para
                                        contratar y
                                        obligarse en los términos del presente contrato, no
                                        se tiene ninguna limitación legal, contractual, de alguna autoridad judicial o
                                        administrativa, o de cualquier otra índole
                                        para celebrar el presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>e)</strong> Los recursos que utilizará para pagar las obligaciones
                                        derivadas
                                        del presente contra no son, ni serán de procedencia
                                        ilícita.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>f)</strong> Es su voluntad celebrar el presente contrato, en los
                                        términos y
                                        bajo las condiciones que el mismo establece.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>g)</strong> Que <strong>GOLDBERGFUND</strong> le hizo del conocimiento
                                        antes
                                        de la firma de este contrato: Su contenido, tasa de interés
                                        ordinario, moratorio, comisiones, seguros o gastos que se generarán por la
                                        celebración del presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>h)</strong> Que <strong>GOLDBERGFUND</strong> le explico el CAT
                                        reflejado en
                                        la carátula del contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>i)</strong> Que es única propietaria en pleno dominio y posesión de <strong>EL INMUEBLE</strong> ubicado en (colocar domicilio), con una 
                                        superficie de (colocar metros cuadrados), con las medidas y colindancias siguientes (colocar colindancias) (en lo 
                                        sucesivo <strong>“EL INMUEBLE”</strong>), tal como se desprende de la escritura pública número <input type="text" class="underline-input"> otorgada ante la fe del 
                                        Licenciado <input type="text" class="underline-input">, Notario Público número <input type="text" class="underline-input">, del Estado de  <input type="text" class="underline-input">, e inscrita en el Registro 
                                        Público de la Propiedad del Estado de <input type="text" class="underline-input">, bajo el folio número <input type="text" class="underline-input">. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>j)</strong> Declara que <strong>EL INMUEBLE</strong> se encuentra libre de todo gravamen y no está sujeto a ningún procedimiento judicial, 
                                        fiscal, administrativo o laboral alguno y, para acreditarlo, le ha otorgado a GOLDBERGFUND el Certificado de Libertad 
                                        de Gravamen correspondiente, actualizado a la fecha de firma del presente instrumento, expedido por el delegado del 
                                        Registro Público de la Propiedad y del Comercio del Estado de <input type="text" class="underline-input">, Delegación <input type="text" class="underline-input">. 
                                    </div>

                                    <div class="title-clausula">
                                        <strong>
                                            III.- Declara EL OBLIGADO SOLIDARIO, bajo protesta de decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Los datos generales son y corresponden a los que han quedado
                                        señalados en la carátula del presente, la cual es
                                        presentada como Anexo A y en los formatos de identificación establecidos por
                                        <strong>GOLDBERGFUND</strong> es: (i) una persona
                                    </div>
                                </div>
                            </slot>

                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Botón de descarga -->
                <div class="form-actions">
                    <button class="download-btn">Descargar PDF</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { useContractStore } from '@/pinia/LoanApplications/Legal/useContractStore.module';

const store = useContractStore();
const contractContent = ref(null);

// Acceder a la instancia de la app
const app = getCurrentInstance();

const handleSubmit = () => {
    store.saveData();
};

onMounted(() => {
    store.setContractContent(contractContent.value);
});
</script>

<style scoped>
/* Conversión a píxeles (96 DPI) */
/* :root {
    --dpi: 96;
    --cm-to-px: calc(var(--dpi) / 2.54);
} */

.page-simulator {
    /*background-color: #f5f5f5;
    padding: 20px;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);*/
}

.paper-sheet {
    /* width: calc(21.59cm * var(--cm-to-px));
    height: calc(27.94cm * var(--cm-to-px)); */
    background-color: white;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    position: relative;
    display: flex;
    flex-direction: column;
}

.paper-sheet.pdf-mode {
    /*width: 793px;
    height: 1122px;
    overflow: hidden;
    padding: 95px 113px;
    box-sizing: border-box;*/
}

/* Márgenes principales */
.margin-top-sheet,
.margin-bottom-sheet {
    /*height: calc(2.5cm * var(--cm-to-px));
    border-bottom: 1px dashed #ccc;*/
    /*height: calc(2.5cm * var(--cm-to-px));
    border-top: 1px dashed #ccc;*/
    margin-top: 95px;
}

.margin-left-sheet,
.margin-right-sheet {
    /*width: calc(3cm * var(--cm-to-px));
    border-right: 1px dashed #ccc;*/
    /*width: calc(3cm * var(--cm-to-px));
    border-left: 1px dashed #ccc;*/
    /*margin-left: 113px;*/
    margin-left: 131px;
}

.content-area {
    display: flex;
    flex: 1;
}

.main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
}

/* Encabezado y pie de página */
/* .header-space {
    height: calc(1.25cm * var(--cm-to-px));
    border-bottom: 1px dotted #ddd;
}

.footer-space {
    height: calc(1.25cm * var(--cm-to-px));
    border-top: 1px dotted #ddd;
    margin-top: auto;
} */

/* Visualización de medidas (opcional) */
/* .margin-top::after,
.margin-bottom::after,
.margin-left::after,
.margin-right::after {
    content: attr(data-size);
    position: absolute;
    color: #999;
    font-size: 10px;
} */

.margin-top::after {
    bottom: 2px;
    right: 5px;
}

/* .margin-bottom::after {
    top: 2px;
    right: 5px;
} */

.margin-left::after {
    top: 5px;
    right: 2px;
    transform: rotate(90deg);
    transform-origin: right top;
}

.margin-right::after {
    top: 5px;
    left: 2px;
    transform: rotate(-90deg);
    transform-origin: left top;
}


.contract-container {
    /*width: 100%;
    margin: 0 auto;*/
    /**    max-width: 780px; */
    margin: 0px;
    padding: 0px;
}

.content-ref {
    margin: 0px;
    padding: 0px;
}

.contract-page {
    font-family: "Calibri Light", Calibri, "Gill Sans", "Gill Sans MT", sans-serif;
}

.contract-number {
    text-align: right;
    /*margin-bottom: 25px;*/
    margin-bottom: 40px;
}

.contract-title p {
    text-align: justify;
}

.text-uppercase {
    text-transform: uppercase;
}

.underline-input {
    border: none;
    border-bottom: 1px solid #000;
    background: transparent;
    font-family: Arial, sans-serif;
    /*margin-right: 8px;*/
}

.underline-input-sm {
    width: 12%;
}

.underline-input-md {
    width: 25%;
}

.underline-input-lg {
    width: 50%;
}

.underline-input-xl {
    width: 100%;
}

.underline-input:focus,
.underline-input-sm:focus,
.underline-input-md:focus,
.underline-input-lg:focus,
.underline-input-xl:focus {
    outline: none;
    border-bottom: 2px solid #f8a845;
}

.section-title {
    font-weight: bold;
    margin: 15px 0 15px 0;
    text-transform: uppercase;
    text-decoration: underline;
    justify-self: center;
}

.declaration-item {
    margin-left: 18px;
}

.title-clausula-exception {
    margin-bottom: 15px;
}

.title-clausula {
    margin-bottom: 15px;
    margin-top: 15px;
}

/*.space-declaration {
    margin-left: 6px;
}*/

.space-letter {
    margin-right: 14px;
}

.list-declaration {
    /*margin-left: 11px;*/
    /*margin-left: 6px;*/
}

.list-declaration li {
    /*padding-left: 14px;*/
    padding-left: 10px;
}


/**Descargar */
.pdf-mode {
    font-size: 12px !important;
    /*line-height: 1.2;*/
}

.pdf-mode * {
    font-size: 12px !important;
    /*line-height: 1.2;*/
}


/** Formato de iniciso */
ol.list-text.custom-alpha {
    margin-bottom: 0;
}


ol.list-text.custom-alpha.custom-alpha-position {
    counter-reset: alpha-list 3; /* Empieza desde d (a=1, b=2, c=3, d=4) */
}

ol.custom-alpha {
    list-style-type: none;
    counter-reset: alpha-list;
}

ol.custom-alpha li.list-letter, ol.custom-alpha li.list-letter-normal {
    counter-increment: alpha-list;
    font-weight: bold;
    position: relative;
    margin-left: 0;
    padding-left: 0;
}

ol.custom-alpha li.list-letter::before, ol.custom-alpha li.list-letter-normal::before {
    content: counter(alpha-list, lower-alpha) ") ";
    font-weight: bold;
    position: absolute;
    left: -2em;  /*Ajusta para posicionar el marcador*/
    width: 2em;
    text-align: left;
}

ol.custom-alpha li.list-letter-normal {
    font-weight: normal !important;
}

ol.custom-alpha li.list-letter-normal::before {
    font-weight: normal !important;
}

/**Formato list */
.title-clausula-list {
    margin-bottom: 15px;
    margin-top: 15px;
}

.list-declaration {
    /*margin-left: -47px;*/
    margin-left: -5px;
}

.list-letter, .list-letter-normal {
    padding-left: 12px
}

span.list-title {
    font-weight: normal !important;
    /*margin-left: 10px;*/
}

ol.custom-number {
    font-weight: normal;
    /*margin-left: 6px;*/
    margin-left: -26px;
}

.content-clausulas {
    margin: 0px;
    padding: 0px;
}

ol.custom-number li, .content-clausulas p {
    text-align: justify;
}

/**Estilos firmas */
.content-firma{
    /*margin-left: -10px;
    margin-right: -10px;*/
    /* width: calc(100% + 50mm);
    transform: translateX(-25mm); */
    /* width: calc(100% + 35mm);
    transform: translateX(-15mm); */
    /* position: relative;
    transform: translateX(-2mm); */
    /*margin-left: -60px;
    margin-right: -60px;*/
    margin-left: -10px;
    margin-right: -10px;
}

/* Estilo para la sección de firmas en modo normal */
/*.content-firma {
    margin-left: -10px;
    margin-right: -10px;
}*/

/* .pdf-mode .content-firma {
    margin-left: -20px !important;    Extiende 20px hacia la izquierda /
    margin-right: -20px !important;     Extiende 20px hacia la derecha
    width: calc(100% + 40px) !important; Compensa el ancho con los márgenes negativos 
} */

.square-firma {
    border: 1px solid black;
    font-weight: bold;
}

.top-firma {
    text-align: center;
    /*min-height: 40%;*/
    /*min-height: 47%;*/
}

.signature-line{
    margin-top: 70px;
    border-bottom: 1px solid black;
    margin-right: 25px;
    margin-left: 25px;
}

.line-firma-bottom {
    /* margin-bottom: 70px; */
    /*margin-bottom: 50px;*/
}

.bottom-firma {
    margin-top: 50px;
    margin-bottom: 25px;
}

.bottom-firma .form-group {
    display: flex;
}

.bottom-firma-testigo {
    margin-top: 15px;
}

.bottom-firma input {
    flex: 1;
    background: transparent;
    border: none;
    border-bottom: 1px solid #000;
    border-radius: 0px;
    /* margin-left: 8px;
    margin-bottom: 5px;
    padding-bottom: -10px; */
    padding: 0px;
    height: auto;
    margin-left: 8px;
    /*width: 30%;*/
}

.bottom-firma input:focus {
    outline: none;
    border-bottom: 2px solid #f8a845;
}

.separate-firma{
    margin-top: 50px;
    justify-content: space-around;
}

.separate-firm .top-firma{
    /*min-height: 40%;*/
}


@media print {
    /* .single-page-mode {
        zoom: 0.20; Ajuste fino para que quepa en una página .82 
    } */

    /* .contract-page {
      page-break-after: always; Fuerza un salto después de cada página 
    } */

   /*  .paper-sheet{
         page-break-after: always !important; Fuerza un salto después de cada página
    } */


    /* Forzar cada hoja en nueva página */
    .paper-sheet {
        page-break-after: always !important;
        page-break-inside: avoid !important;
        /* height: 1122px;  Altura A4 */
        /*page-break-after: always !important;*/
        /*page-break-inside: avoid !important;*/
       /*  height: 1122px; Altura exacta de A4 en pixels (297mm) 
        overflow: hidden;*/
    }

    /* .contract-page, .declaration-item {
    page-break-inside: avoid !important;
  }  */

    /* Asegurar que el contenido no se divida
    .contract-page, .declaration-item, .list-declaration, .content-clausulas p {
        page-break-inside: avoid !important;
    }*/

    /* Control específico para números de contrato 
    .contract-number {
        page-break-before: always !important;
    }*/

    /* Resetear márgenes para impresión */
    .page-simulator {
        background: none;
        padding: 0;
    }

    .paper-sheet {
        box-shadow: none;
        margin: 0;
        width: 100%;
        height: auto;
    }

    [class*="margin-"] {
        border: none !important;
    }

    /* .paper-sheet{
        page-break-after: always !important;
    }

    .contract-page {
        page-break-inside: avoid !important;
    }

    .contract-number {
        page-break-before: always !important; 
    } */
}
</style>